var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "refsoMeLoginButtons",
      staticClass: "soMeLoginButtons",
      attrs: { id: "soMeLoginButtonsId" },
    },
    [_c("facebookLoginButton"), _c("googleLoginButton")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }